export const result = {
    labels: {
        add_result: "Adicionar resultado",
        add_field: "Adicionar Campo",
        edit_field: "Edit Campo",
        choose_fields: "Escolha os Campos",
        remove_result: "Deletar resultado",
    },
    modals: {
        titles: {
            remove_field: "Deletar Campo",
            remove_result: "Deletar resultado",
        },
        messages: {
            remove_field: "Você deseja remover o <strong>'CAMPO'</strong>?<br/>Esta ação não poderá ser desfeita!",
            remove_result: "Você deseja remover o <strong>'RESULTADO'</strong>?<br/>Esta ação não poderá ser desfeita!",
        },
    },
    texts: {
        result_empty: "Você não tem RESULTADOS para exibir!",
    },
};
